export const MENU_ACCESS = 'menu/access'
